export default "__VITE_ASSET__0943c2b7__"